export const TRACTION_SYSTEM = {
  TRC_TEMP_HIGH: 85,
  TRC_TEMP_LOW: 75,
  MOTOR_TEMP_HIGH: 140,
  MOTOR_TEMP_LOW: 110,
  STATUS: {
    INVERTER_FAULT: 0,
    RECTIFIER_FAULT: 0,
    ISOLATION_MONITOR_FAULT: 1,
    TCU_FAULT: 1,
    LCU_FAULT: 0,
    MOTOR_FAULT: 0,
    COOLING_FAULT_INACTIVE: 1
  }
} as const;
